import { createContext } from 'react';

const NotesContext = createContext({
  notes: [],
  addNote: () => {},
  getNotes: () => {},
  deleteNote: () => {},
  editNote: () => {},
  searchText: '',
  setSearchText: () => {},
  setColor: () => {},
});

export default NotesContext;
